export enum TagMeta {
  MODEL = "tag",
  PK = "id",
}
